export type NavItem = { label: string; href?: string };
export type Category = { title: string; items: NavItem[] };

function item(label: string, href?: string): NavItem {
  return { label, href };
}

export function getFeatureCategories(locale: string): Category[] {
  return [
    {
      title: locale === 'da' ? 'SvendAI' : 'SvendAI',
      items: locale === 'da'
        ? [item('Fakturaanalyse', '/ai'), item('Opsummering', '/ai'), item('Smart forslag', '/ai')]
        : [item('Invoice analysis', '/ai'), item('Summarize', '/ai'), item('Smart suggestions', '/ai')],
    },
    {
      title: locale === 'da' ? 'Produkt' : 'Product',
      items: locale === 'da'
        ? [
            item('Kundekartotek', '/organization/[organizationId]/customers/feature-page'),
            item('Projekter'),
            item('Opgaver'),
            item('Kalender', '/features/calendar'),
            item('Tidsregistrering', '/features/time-tracking'),
            item('Kvalitetssikring', '/features/quality-control'),
            item('Fakturascanning', '/features/invoice-scanning'),
            item('Tilbud', '/features/offer')
          ]
        : [
            item('Customer Database', '/organization/[organizationId]/customers/feature-page'),
            item('Projects'),
            item('Tasks'),
            item('Calendar', '/features/calendar'),
            item('Time Tracking', '/features/time-tracking'),
            item('Quality Control', '/features/quality-control'),
            item('Invoice Scanning', '/features/invoice-scanning'),
            item('Offer', '/features/offer')
          ],
    },
    {
      title: locale === 'da' ? 'Samarbejde' : 'Collaboration',
      items: locale === 'da'
        ? [item('Docs & Wikis'), item('Chat'), item('Whiteboards'), item('Automatiseringer')]
        : [item('Docs & Wikis'), item('Chat'), item('Whiteboards'), item('Automations')],
    },
    {
      title: locale === 'da' ? 'Rapportering' : 'Reporting',
      items: locale === 'da'
        ? [item('Dashboards'), item('Milepæle'), item('Rapporter', '/features/reports'), item('Prioriteret support')]
        : [item('Dashboards'), item('Milestones'), item('Reports', '/features/reports'), item('Priority Support')],
    },
    {
      title: locale === 'da' ? 'Integrationer' : 'Integrations',
      items: locale === 'da'
        ? [item('Google'), item('Gmail'), item('Danløn'), item('API')]
        : [item('Google'), item('Gmail'), item('Danløn'), item('API')],
    },
  ];
}


